import { Incident } from '../state/reduxRepositories/incident/incident.interface';

export const NextIncident = (
  incidents: Incident[],
  targetDate: string,
): Incident | null => {
  return incidents.reduce((acc: Incident | null, item) => {
    const itemCreatedAt = item.originalCreatedAt ?? item.createdAt;

    // Check if the itemCreatedAt is after the target date and before the current accumulator
    if (itemCreatedAt > targetDate && (!acc || itemCreatedAt < acc.createdAt)) {
      return item;
    }
    return acc;
  }, null);
};
